import { motion } from "framer-motion";

export function Reveal({ children, className = "", delay = 0, y = 30 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function FilipinoSun({ className = "", size = 80 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      aria-hidden="true"
    >
      <g fill="currentColor">
        <circle cx="50" cy="50" r="14" />
        {Array.from({ length: 8 }).map((_, i) => {
          const a = (i * 360) / 8;
          return (
            <g key={i} transform={`rotate(${a} 50 50)`}>
              <path d="M50 20 L46 32 L54 32 Z" />
            </g>
          );
        })}
        {Array.from({ length: 8 }).map((_, i) => {
          const a = (i * 360) / 8 + 22.5;
          return (
            <g key={`s${i}`} transform={`rotate(${a} 50 50)`}>
              <path d="M50 26 L47 34 L53 34 Z" opacity="0.7" />
            </g>
          );
        })}
      </g>
    </svg>
  );
}

export function ScriptKicker({ children, className = "" }) {
  return (
    <span className={`font-script text-2xl md:text-3xl text-secondary ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ overline, kicker, title, subtitle, align = "left", testid }) {
  const alignCls = align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl";
  return (
    <div className={alignCls} data-testid={testid}>
      {overline && (
        <div className={`overline flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
          <span className="w-8 h-px bg-secondary" />
          <span>{overline}</span>
          <span className="w-8 h-px bg-secondary" />
        </div>
      )}
      {kicker && (
        <div className={`mt-3 ${align === "center" ? "" : ""}`}>
          <ScriptKicker>{kicker}</ScriptKicker>
        </div>
      )}
      <h2 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl font-medium text-foreground leading-[1.02] tracking-tight text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-base lg:text-lg text-muted-foreground leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
